import {Button, Grid, GridItem, Flex, Heading, Text} from '@chakra-ui/react'
import {PropTypes} from 'prop-types'
import {useTranslation} from 'react-i18next'

import {Header, Introduction} from '../components'

const InvitationTypeModal = ({goToNextStep, goToPreviousStep}) => {
  const {t} = useTranslation('invitePayers')
  const selectCustomerScreen = () => goToNextStep('select_customer')
  const selectCustomersScreen = () => goToNextStep('select_customers')

  return (
    <Grid templateColumns="repeat(3, 1fr)" height="full">
      <Introduction />
      <GridItem colSpan={2} position="relative">
        <Flex direction="column" height="full" pb="10%">
          <Header goToPreviousStep={goToPreviousStep} goToPreviousStepEnabled />
          <Flex
            direction="column"
            width="390px"
            gap="md"
            color="black"
            align="center"
            justify="center"
            flex="1"
            mx="auto"
          >
            <Heading
              fontWeight="normal"
              lineHeight="90%"
              align="left"
              justify="center"
            >
              {t('modal.steps.invitationType.contentSection.title')}
            </Heading>
            <Text fontWeight="normal" align="left" lineHeight="150%">
              {t('modal.steps.invitationType.contentSection.paragraphOne')}
            </Text>
            <Text fontWeight="normal" align="left" lineHeight="150%">
              {t('modal.steps.invitationType.contentSection.paragraphTwo')}
            </Text>
            <Flex width="100%" direction="column" gap="xs">
              <Button
                className="fs-unmask"
                mt="xs"
                variant="secondary"
                size="md"
                width="45%"
                onClick={selectCustomerScreen}
              >
                <Text>
                  {t('modal.steps.invitationType.ctaButtons.individual')}
                </Text>
              </Button>
              <Button
                className="fs-unmask"
                mt="xs"
                variant="secondary"
                size="md"
                width="35%"
                onClick={selectCustomersScreen}
              >
                <Text>{t('modal.steps.invitationType.ctaButtons.bulk')}</Text>
              </Button>
            </Flex>
          </Flex>
        </Flex>
      </GridItem>
    </Grid>
  )
}

InvitationTypeModal.propTypes = {
  goToNextStep: PropTypes.func.isRequired,
  goToPreviousStep: PropTypes.func.isRequired,
}

export default InvitationTypeModal
